package com.kyant.backdrop.catalog

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.text.BasicText
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableIntStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.kyant.backdrop.backdrops.rememberLayerBackdrop
import com.kyant.backdrop.catalog.components.LiquidBottomTab
import com.kyant.backdrop.catalog.components.LiquidBottomTabs

data class NavItem(
    val label: String,
    val href: String
)

// Keep this in sync with Header.astro --tabbar-shadow-bleed-x.
private val HorizontalShadowBleed = 72.dp

@Composable
fun MainContent(
    pathname: String,
    onNavigate: (String) -> Unit
) {
    val isLightTheme = !isSystemInDarkTheme()
    val contentColor = if (isLightTheme) Color.Black else Color.White
    val backdrop = rememberLayerBackdrop()
    val items = remember {
        listOf(
            NavItem("Home", "/"),
            NavItem("Blog", "/blog"),
            NavItem("About", "/about")
        )
    }
    var selectedTabIndex by remember(pathname) {
        mutableIntStateOf(
            items.indexOfFirst { item ->
                pathname == item.href || (item.href != "/" && pathname.startsWith(item.href))
            }.takeIf { it >= 0 } ?: 0
        )
    }

    Box(
        Modifier
            .fillMaxSize(),
        contentAlignment = Alignment.Center
    ) {
        Box(
            Modifier
                .fillMaxWidth()
                // Offset the extra root canvas bleed so the visual tab width stays unchanged.
                .padding(horizontal = 8.dp + HorizontalShadowBleed)
                .height(72.dp)
        ) {
            LiquidBottomTabs(
                selectedTabIndex = { selectedTabIndex },
                onTabSelected = { index ->
                    selectedTabIndex = index
                    val target = items[index].href
                    if (target != pathname) {
                        onNavigate(target)
                    }
                },
                backdrop = backdrop,
                tabsCount = items.size,
                modifier = Modifier.fillMaxWidth()
            ) {
                items.forEachIndexed { index, item ->
                    LiquidBottomTab({ selectedTabIndex = index }) {
                        BasicText(
                            item.label,
                            style = TextStyle(contentColor, 12.sp)
                        )
                    }
                }
            }
        }
    }
}
